export default __webpack_public_path__ + "static/media/regi.099886aa.png";